var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserDown01 = function SvgUserDown01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 11.625H5.625c-1.047 0-1.57 0-1.996.13a3 3 0 0 0-2 2c-.129.425-.129.948-.129 1.995M12 13.5l2.25 2.25m0 0 2.25-2.25m-2.25 2.25v-4.5m-3.375-5.625a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Z"
  })));
};
export default SvgUserDown01;